'use client'
import clsx from 'clsx'

export default function Select({
  labelFor,
  options,
  value,
  onChange,
  className,
}) {
  return (
    <div className="flex flex-col gap-2">
      {labelFor && <label className="byline">{labelFor}</label>}
      <select
        value={value}
        onChange={onChange}
        className={clsx(
          'appearance-none rounded-sm border border-border bg-background px-3 py-2 font-sans text-sm font-medium text-foreground transition-colors',
          'hover:border-foreground/40',
          'focus:border-foreground focus:outline-none focus:ring-1 focus:ring-foreground',
          'dark:bg-card',
          className
        )}
      >
        {options.map((option) => (
          <option key={option.slug} value={option.slug}>
            {option.name}
          </option>
        ))}
      </select>
    </div>
  )
}
